import { useEffect, useRef } from 'react'
import { useGatewayStatus } from '@renderer/overlay/atoms'

interface UseGatewayConnectOptions {
  enabled?: boolean
}

export function useGatewayConnect(
  onConnect: () => void | Promise<void>,
  { enabled = true }: UseGatewayConnectOptions = {},
) {
  const gatewayStatus = useGatewayStatus()
  const previousStatusRef = useRef(gatewayStatus)
  const onConnectRef = useRef(onConnect)

  useEffect(() => {
    onConnectRef.current = onConnect
  }, [onConnect])

  useEffect(() => {
    const previousStatus = previousStatusRef.current
    const didConnect = previousStatus !== 'connected' && gatewayStatus === 'connected'
    previousStatusRef.current = gatewayStatus

    if (!enabled || !didConnect) {
      return
    }

    Promise.resolve(onConnectRef.current()).catch((error) => {
      console.error('Failed to handle gateway connect:', error)
    })
  }, [enabled, gatewayStatus])
}
